(function() {
    // Translations
    // Wrap Liquid-generated JSON values inside a template string so the JS parser
    // doesn't flag Liquid tags as syntax errors before Shopify renders them.
    const translations = JSON.parse(`{
        "showItems": "แสดงสินค้า",
        "sortBy": "เรียงจาก:",
        "featured": "สินค้าแนะนำ",
        "bestSelling": "สินค้าขายดี",
        "newArrivals": "สินค้ามาใหม่",
        "priceLowToHigh": "ราคา: น้อย-มาก",
        "priceHighToLow": "ราคา: มาก-น้อย"
    }`);

    // Run the function when DOM is fully loaded
    document.addEventListener('DOMContentLoaded', function() {
        // Run after a slight delay to ensure all elements are loaded
        setTimeout(function() {
            changeToolbarLabels();
        }, 500);
    });

    // Also run on window load to handle any delayed rendering
    window.addEventListener('load', function() {
        changeToolbarLabels();
    });

    function changeToolbarLabels() {
        // Change the "Show items" label
        

        // Change the "Sort by" label
        

        // Change the dropdown items text
        

        // Reorder dropdown items (move New arrivals before Price: Low to High)
        
    }

    function changeShowItemsLabel() {
        // Find the "Show items" label in the toolbar
        const showItemsLabel = document.querySelector('#CollectionProductGrid toolbar-item > div > div:nth-child(3) > div:first-child > label');

        if (showItemsLabel) {
            showItemsLabel.textContent = translations.showItems;
            console.log('Show items label text changed successfully');
        } else {
            console.log('Could not find the show items label to change text');

            // Try a more general approach using all labels in the toolbar
            const allToolbarLabels = document.querySelectorAll('#CollectionProductGrid toolbar-item label');
            if (allToolbarLabels.length > 0) {
                // Find the label that might contain text about showing items
                allToolbarLabels.forEach(label => {
                    if (label.textContent.includes('Show') ||
                        label.textContent.includes('items') ||
                        label.textContent.includes('products') ||
                        label.textContent.includes('per page')) {
                        label.textContent = translations.showItems;
                    }
                });
            }
        }
    }

    function changeSortByLabel() {
        // Find the "Sort by" label in the toolbar
        const sortByLabel = document.querySelector('#CollectionProductGrid toolbar-item > div > div:nth-child(3) > div:nth-child(2) > label');

        if (sortByLabel) {
            sortByLabel.textContent = translations.sortBy;
            console.log('Sort by label text changed successfully');
        } else {
            console.log('Could not find the sort by label to change text');

            // Try a more general approach using all labels in the toolbar
            const allToolbarLabels = document.querySelectorAll('#CollectionProductGrid toolbar-item label');
            if (allToolbarLabels.length > 0) {
                // Find the label that might contain text about sorting
                allToolbarLabels.forEach(label => {
                    if (label.textContent.includes('Sort') ||
                        label.textContent.includes('by') ||
                        label.textContent.includes('sorting')) {
                        label.textContent = translations.sortBy;
                        console.log('Found and changed sort by label using alternative method');
                    }
                });
            }
        }
    }

    function reorderDropdownItems() {
        try {
            // Get the dropdown list
            const dropdownList = document.querySelector('#CollectionProductGrid toolbar-item > div > div:nth-child(3) > div:nth-child(2) > div > ul');

            if (!dropdownList) {
                console.log('Could not find dropdown list for reordering');
                return;
            }

            // Get the new arrivals item (8th item)
            const newArrivalsItem = dropdownList.querySelector('li:nth-child(8)');

            // Get the price low to high item (5th item)
            const priceLowToHighItem = dropdownList.querySelector('li:nth-child(5)');

            if (!newArrivalsItem || !priceLowToHighItem) {
                console.log('Could not find items for reordering');
                return;
            }

            // Insert the new arrivals item before the price low to high item
            dropdownList.insertBefore(newArrivalsItem, priceLowToHighItem);
            console.log('Reordered dropdown items successfully');

        } catch (error) {
            console.error('Error reordering dropdown items:', error);
        }
    }

    function changeDropdownItems() {
        // Try to change both dropdown items
        setTimeout(function() {
            // Find the first item in the sort dropdown (Featured)
            const featuredItem = document.querySelector('#CollectionProductGrid toolbar-item > div > div:nth-child(3) > div:nth-child(2) > div > ul > li:first-child > span');
            if (featuredItem) {
                featuredItem.textContent = translations.featured;
                console.log('Featured item text changed successfully');
            }

            // Find the second item in the sort dropdown (Best selling)
            const bestSellingItem = document.querySelector('#CollectionProductGrid toolbar-item > div > div:nth-child(3) > div:nth-child(2) > div > ul > li:nth-child(2) > span');
            if (bestSellingItem) {
                bestSellingItem.textContent = translations.bestSelling;
                console.log('Best selling item text changed successfully');
            }

            // Find the 8th item in the sort dropdown (New arrivals)
            const newArrivalsItem = document.querySelector('#CollectionProductGrid toolbar-item > div > div:nth-child(3) > div:nth-child(2) > div > ul > li:nth-child(8) > span');
            if (newArrivalsItem) {
                newArrivalsItem.textContent = translations.newArrivals;
                console.log('New arrivals item text changed successfully');
            }

            // Find the 5th item in the sort dropdown (Price: Low to High)
            const priceLowToHighItem = document.querySelector('#CollectionProductGrid toolbar-item > div > div:nth-child(3) > div:nth-child(2) > div > ul > li:nth-child(5) > span');
            if (priceLowToHighItem) {
                priceLowToHighItem.textContent = translations.priceLowToHigh;
                console.log('Price: Low to High item text changed successfully');
            }

            // Find the 6th item in the sort dropdown (Price: High to Low)
            const priceHighToLowItem = document.querySelector('#CollectionProductGrid toolbar-item > div > div:nth-child(3) > div:nth-child(2) > div > ul > li:nth-child(6) > span');
            if (priceHighToLowItem) {
                priceHighToLowItem.textContent = translations.priceHighToLow;
                console.log('Price: High to Low item text changed successfully');
            }

            // เพิ่มการค้นหาตัวเลือก price-descending โดยตรงตาม data-value เพื่อความแม่นยำมากขึ้น
            const allPriceDescItems = document.querySelectorAll('span[data-value="price-descending"]');
            if (allPriceDescItems.length > 0) {
                allPriceDescItems.forEach(item => {
                    item.textContent = translations.priceHighToLow;
                });
                console.log(`Updated ${allPriceDescItems.length} price-descending items directly via data-value`);
            }

            // If direct selectors fail, try a more general approach
            if (!featuredItem || !bestSellingItem || !newArrivalsItem || !priceLowToHighItem || !priceHighToLowItem) {
                const dropdownItems = document.querySelectorAll('#CollectionProductGrid toolbar-item ul li span');
                if (dropdownItems.length > 0) {
                    // Loop through all dropdown items to find and change them
                    dropdownItems.forEach((item, index) => {
                        const text = item.textContent.toLowerCase();
                        if (text.includes('featured') || text.includes('recommended')) {
                            item.textContent = translations.featured;
                            console.log('Found and changed featured item text using alternative method');
                        } else if (text.includes('best selling') || text.includes('best-selling') || text.includes('bestselling')) {
                            item.textContent = translations.bestSelling;
                            console.log('Found and changed best selling item text using alternative method');
                        } else if (text.includes('new') || text.includes('newest') || text.includes('new arrivals') || text.includes('date') || text.includes('created')) {
                            item.textContent = translations.newArrivals;
                            console.log('Found and changed new arrivals item text using alternative method');
                        } else if (text.includes('price: low to high') || text.includes('price low to high') || (text.includes('price') && text.includes('low'))) {
                            item.textContent = translations.priceLowToHigh;
                            console.log('Found and changed price low to high item text using alternative method');
                        } else if (text.includes('price: high to low') || text.includes('price high to low') || (text.includes('price') && text.includes('high')) || text.includes('price-descending')) {
                            item.textContent = translations.priceHighToLow;
                            console.log('Found and changed price high to low item text using alternative method');
                        }
                    });
                }
            }

            // Also update the selected option if it's one of these values
            const selectedOption = document.querySelector('#CollectionProductGrid toolbar-item > div > div:nth-child(3) > div:nth-child(2) > div > div:first-child > span:first-child');
            if (selectedOption) {
                const text = selectedOption.textContent.toLowerCase();
                if (text.includes('featured') || text.includes('recommended')) {
                    selectedOption.textContent = translations.featured;
                } else if (text.includes('best selling') || text.includes('best-selling') || text.includes('bestselling')) {
                    selectedOption.textContent = translations.bestSelling;
                } else if (text.includes('new') || text.includes('newest') || text.includes('new arrivals') || text.includes('date') || text.includes('created')) {
                    selectedOption.textContent = translations.newArrivals;
                } else if (text.includes('price: low to high') || text.includes('price low to high') || (text.includes('price') && text.includes('low'))) {
                    selectedOption.textContent = translations.priceLowToHigh;
                } else if (text.includes('price: high to low') || text.includes('price high to low') || (text.includes('price') && text.includes('high')) || text.includes('price-descending')) {
                    selectedOption.textContent = translations.priceHighToLow;
                }
            }
        }, 1000); // Extra delay for dropdown items that might be loaded dynamically
    }
})();
